export default __webpack_public_path__ + "static/media/counterparty.16b3331a.png";